import React from "react";
import { useState } from "react";

const Tabs = ({ tabs, currentActiveTab, handleTabChange }) => {
  const [activeTab, setActiveTab] = useState(currentActiveTab || tabs[0].value);

  const handleTabSelect = (value) => {
    setActiveTab(value);
    if (handleTabChange) {
      handleTabChange(value);
    }
  };
  return (
    <div>
      <ul className="flex flex-row  h-[30px] flex-wrap rounded-[13px] border-vb-border bg-white">
        {tabs.map((tab, index) => {
          const value = tab.value || tab.label.toLowerCase();
          return (
            <li
              key={`tab-index-` + tab.value + index}
              class="text-center h-full"
            >
              <a
                onClick={() => handleTabSelect(value)}
                className={`cursor-pointer rounded-[13px] h-full flex items-center px-3 text-xs font-medium ${
                  activeTab === value
                    ? "bg-dark-gray text-white font-bold"
                    : "text-body-color hover:bg-gray-300 dark:text-dark-6 dark:hover:text-white"
                }`}
                role="tab"
                aria-selected="true"
              >
                {tab.label}
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Tabs;
